import { api } from './api';
import { fetchResource, updateResource } from './fetchResource';

export function fetchJobsModule() {
  return dispatch => fetchResource(dispatch, 'modules/jobs', 'JOBS_MODULE_FETCHED');
}

export function updateJobsModule(payload) {
  return dispatch => updateResource(dispatch, 'modules/jobs', payload, 'JOBS_MODULE_FETCHED');
}
